import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@Component({
  standalone: true,
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
  imports: [RouterOutlet, NzLayoutModule],
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('TopNavBarHost', { read: ViewContainerRef, static: true }) public TopNavBarHost: ViewContainerRef;
  TopNavBarContainer;

  @ViewChild('FooterHost', { read: ViewContainerRef, static: true }) public FooterHost: ViewContainerRef;
  FooterContainer;

  isLoaded: boolean = false;
  showContent: boolean = true;
  isFirstTime: any;
  loadForHome: boolean = false;

  constructor() {
    console.log('loadForHome', this.loadForHome);
    this.loadForHome = true;
    this.loadTopNavBar();
    this.loadFooter();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.TopNavBarHost?.clear();
    this.FooterHost?.clear();
  }

  loadTopNavBar() {
    import('./../components/topnavbar/topnavbar.component').then(({ TopnavbarComponent }) => {
      this.TopNavBarHost?.clear();
      this.TopNavBarContainer = this.TopNavBarHost.createComponent(TopnavbarComponent);
      this.TopNavBarContainer.instance.mobileMenuToggelled.subscribe((data: any) => {
        this.showContent = data;
      });
    });
  }

  loadFooter() {
    import('./../components/footer/footer.component').then(({ FooterComponent }) => {
      this.FooterHost?.clear();
      this.FooterContainer = this.FooterHost.createComponent(FooterComponent);
    });
  }
}
